import React from 'react'

const Footer = () => {
  return (
    <div className='footer'>
        <div className='socials'>
        <a href='https://www.linkedin.com/in/olamide-akinniyi-10420b187'><i className="devicon-linkedin-plain"></i></a>
        <a href='https://github.com/Olamide-Bello'><i className="devicon-github-original"></i></a>
        <a href='https://twitter.com/akin_olamideart'><i className="devicon-twitter-original"></i></a>
        </div>
        <p>&copy; Olamide Bello</p>
    </div>
  )
}

export default Footer